import cn from 'bem-cn';

import { Stack } from '../../../../UI';

import { ChallengeChecklistItemProps } from './ChallengeChecklistItem.types';
import './ChallengeChecklistItem.scss';

const b = cn('challenge-checklist-item');

export const ChallengeChecklistItem = (props: ChallengeChecklistItemProps) => {
    const { index, text } = props;

    return (
        <Stack direction="row" spacing={12} className={b()} alignItems="center">
            <Stack className={b('index-container')} justifyContent="center" alignItems="center">
                <p>{index}</p>
            </Stack>
            <p>{text}</p>
        </Stack>
    );
};
